import { IExportColumnModel } from "../../../../../shared/models";

export const ExtractionEnginesColumnList: IExportColumnModel[] = [
]